import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoutes } from './Index'

import FactoryFiltersContextProvider from '../context/FactoryFiltersContext'
import { AuthContext } from '../context/AuthContext'

import Factory from '../pages/Factory/Index'

export default function FactoryRoutes (): JSX.Element {
  const { auth } = useContext(AuthContext)
  return (
    <FactoryFiltersContextProvider>
      <Switch>
        <PrivateRoutes path="/industrias" component={Factory} auth={auth} />
      </Switch>
    </FactoryFiltersContextProvider>
  )
}
